export default __webpack_public_path__ + "static/ely-3-c3e4f6c08d7fa862c04bace5012f4c2b.jpg";